import SoftSelect from "components/SoftSelect";

const LanguageSelect = ({
  language,
  languageOptions,
  disabled,
  onLanguageChange,
}) => {
  const formatLabel = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const selectedOption = languageOptions
    .map((opt) => ({
      label: formatLabel(opt.label),
      value: opt.value.toLowerCase(),
    }))
    .find((opt) => opt.value === language.toLowerCase());

  return (
    <SoftSelect
      value={selectedOption}
      options={languageOptions.map((opt) => ({
        label: formatLabel(opt.label),
        value: opt.value.toLowerCase(),
      }))}
      isDisabled={disabled}
      isSearchable={false}
      onChange={onLanguageChange}
      className="editor-language-select"
      menuPlacement="bottom"
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

export default LanguageSelect;
